export const generateViewKey = (view, isEquipmentView, savedFilter, signeeFilter, listGroupByView, displayPreset, currentSideBarPanel, isTimelineView = "none") => {
    const viewType = isEquipmentView ? 'equipment' : 'bookings';
    const filterKey = savedFilter || 'none';
    const signeeKey = signeeFilter?.userId || 'all';

    return `${view}-${viewType}-${filterKey}-${signeeKey}-${listGroupByView}-${displayPreset}-${currentSideBarPanel}-${isTimelineView}`;
};

export const resetViewState = (stateSetters, dispatchAction) => {
    const {
        setTempRowData,
        setSelectedEquipment,
        setEvents,
        setSelectedList
    } = stateSetters;

    // Clear temporary data
    if (setTempRowData) setTempRowData([]);
    if (setSelectedEquipment) setSelectedEquipment([]);
    if (setEvents) setEvents([]);
    if (setSelectedList) setSelectedList([]);

    // Clear pagination and loading states
    if (dispatchAction) {
        dispatchAction({ type: "clearAll" });
    }
};


export const shouldReloadOnViewSwitch = (currentState, previousState) => {
    if (!previousState) return true;

    return (
        currentState.view !== previousState.view ||
        currentState.isEquipmentView !== previousState.isEquipmentView ||
        currentState.savedFilter !== previousState.savedFilter ||
        currentState.signeeUserId !== previousState.signeeUserId
    );
};

export const logViewSwitch = (view, isEquipmentView, savedFilter, signeeFilter) => {
  const viewType = isEquipmentView ? 'Equipment Timeline' : 'Booking Calendar';
  const filterInfo = savedFilter ? `Filter: ${savedFilter}` : 'No filter';
  const signeeInfo = signeeFilter?.userId ? `Signee: ${signeeFilter.userId}` : 'All users';
  console.log(viewType, filterInfo, signeeInfo)
};

const ViewSwitchingUtils = {
    generateViewKey,
    resetViewState,
    shouldReloadOnViewSwitch,
    logViewSwitch
};

export default ViewSwitchingUtils;
